import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { handleChangeDataHeaderDesktop, RemovePrevSearchHistory } from '../../../../redux/actions/partials/header/headerDesktop';
import { handleChangeDataHeaderMobile } from '../../../../redux/actions/partials/header/headerMobile';
import apiRequest from '../../../../utils/apiRequest';
import { SEARCH_SUGGESTION_GET } from '../../../../apis';
import { Sheet } from 'react-modal-sheet';


const SheetSearchMobile = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isSheetSearchOpen } = useSelector(state => state.headerMobile);
    const { searchTxt, searchResultWithCats, searchResultWithoutCats, prevSearchHistory, topSearchKeywords } = useSelector(state => state.headerDesktop);


    const inputRef = useRef(null);
    useEffect(() => {
        if(isSheetSearchOpen) 
            setTimeout(() => {
                inputRef.current.focus();
            }, 100);
    }, [isSheetSearchOpen]);


    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState(null);

    // debounce
    const debounceTimeout = useRef(null);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataHeaderDesktop(name, value));

        // اگه کمتر از ۲ کاراکتر بود → autocomplete نشون داده نشه
        if (value.length < 2) {
            dispatch( handleChangeDataHeaderDesktop('searchResultWithCats', []) );
            dispatch( handleChangeDataHeaderDesktop('searchResultWithoutCats', []) );
            return;
        }

        // debounce: هر بار تایپ → درخواست قبلی رو پاک کن
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            fetchSuggestions(value);
        }, 400); // مثلا ۴۰۰ms
    };

    const fetchSuggestions = async (query) => {
        // اگر درخواست قبلی هنوز در جریانه، cancel کن
        if (controller) {
            controller.abort();
        }

        const newController = new AbortController();
        setController(newController);

        setLoading(true);

        apiRequest({
            dispatch,
            endpoint: `${SEARCH_SUGGESTION_GET}?q=${encodeURIComponent(query)}`,
            method: 'get',
            token: null,
            signal: newController.signal,
            onSuccess: (res) => {
                // setSuggestions(res.data); // جواب رو بریز توی state
                dispatch( handleChangeDataHeaderDesktop('searchResultWithCats', res.withCats) );
                dispatch( handleChangeDataHeaderDesktop('searchResultWithoutCats', res.withoutCats) );
                // handleHideSearchHistory();
            },
            onError: (err) => {
                console.error(err);
            }
        }).finally(() => setLoading(false));
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && searchTxt.trim() !== "") {
            closeSheetSearch();
            navigate(`/search?q=${encodeURIComponent(searchTxt.trim())}`);
        }
    };


    const deleteRecentSearchHistory = () => {
        dispatch( RemovePrevSearchHistory() );
    };

    const closeSheetSearch = () => {
        dispatch(handleChangeDataHeaderMobile('isSheetSearchOpen', false));
    };

    const navigateToSearchPage = (url, txt = "") => {
        console.log('txt');
        console.log(txt);
        if(txt !== "") {
            console.log('umad inja');
            dispatch(handleChangeDataHeaderDesktop('searchTxt', txt));
        }
        closeSheetSearch();
        navigate(url);
    }


    return (

        

        <Sheet style={{zIndex: "4"}} isOpen={isSheetSearchOpen} onClose={closeSheetSearch} detent="content-height" >
            <Sheet.Container >
                
                <Sheet.Content>

                    <div className="fixed z-4 top-0 left-0 flex items-center justify-center w-full BottomSheet_BottomSheet__pzJd_ BottomSheet_BottomSheet__animation___9TAU flex items-end w-full h-full" style={{zIndex: 6}}>
                        <div className="bg-neutral-000 absolute shadow-2 w-full BottomSheet_BottomSheet__animation___9TAU BottomSheet_BottomSheet__content--mobile__wyx7Y w-screen overflow-hidden flex styles_bottomSheetContent__Qv8Te h-full" width={691} height={607} style={{transform: 'translateY(0px)'}}>
                            <div className="grow">
                                <div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1">
                                    <div className="w-full z-1 bg-neutral-000 py-3 lg:py-0" width={691} height={40}>
                                        <div className="flex items-center">
                                            <div className="grow text-h5">
                                                <div>
                                                    <div data-cro-id="searchbox-click" className="flex items-center SearchInput_SearchInput__HB9qi SearchInput_SearchInput__searchInput__CEpaj SearchInput_SearchInput--active__U9csa rounded-md bg-neutral-100 h-10 border-none bg-neutral-000 mx-4 z-3">
                                                        <div className="w-full lg:rounded-full rounded-md">
                                                            <div className="flex items-center justify-between grow min-w-0 h-9 px-3">
                                                                <div className="flex cursor-pointer" onClick={closeSheetSearch}>
                                                                    <svg style={{width: '24px', height: '24px', fill: 'var(--color-neutral-500)'}}>
                                                                        <use xlinkHref="#arrowRight" />
                                                                    </svg>
                                                                </div>
                                                                <span data-cro-id="searchbox-type" className="grow h-10">
                                                                    <label className="FormComponentFrame_FormComponentFrame__PIUpy w-full">
                                                                        <div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I px-2 flex items-center !px-0 !h-10">
                                                                            <div className="grow text-body-3">
                                                                                <input className="px-2 TextField_TextField__input__hFMFl text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--primary__IZ6Ku text-neutral-500 text-body-2 lg:text-body-2 text-button-1 h-full text-neutral-500" id="searchInput" type="text" name="searchTxt" autoComplete="off" value={searchTxt} onChange={handleChangeInputs} onKeyDown={handleKeyDown} ref={inputRef} />
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="absolute top-5 right-16 flex" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    { searchResultWithCats.length === 0 && searchResultWithoutCats.length === 0 ?
                                    <div className="grow flex flex-col overflow-y-auto">
                                        <div className="grow flex flex-col styles_children__hHq5Q hide-scrollbar">
                                            <div className="pb-4 br-list-vertical-no-padding-200 top-0 right-0">
                                                <div className="lg:px-4">
                                                    <div className="px-5 flex flex-col">
                                                        <div className="br-list-vertical-no-padding-200" />
                                                    </div>
                                                </div>

                                                { prevSearchHistory.length > 0 &&
                                                    <div className="py-2 hide-scrollbar border-complete-b border-b-neutral-500 pb-4">
                                                        <span className="cursor-pointer py-3 break-words block px-5 lg:px-4 xs:py-2">
                                                            <div className="flex justify-between items-start">
                                                                <div className="flex shrink-0 ml-4 mt-0.5">
                                                                    <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
                                                                        <use xlinkHref="#searchHistory" />
                                                                    </svg>
                                                                </div>
                                                                <div className="grow text-right">
                                                                    <span className="grow text-subtitle-strong text-neutral-700">آخرین جستجوهای شما
                                                                    </span>
                                                                    <div />
                                                                </div>
                                                                <div className="flex items-center shrink-0 mr-4">
                                                                    <div className="flex cursor-pointer" onClick={deleteRecentSearchHistory} >
                                                                        <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
                                                                            <use xlinkHref="#delete" />
                                                                        </svg>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </span>
                                                        <div className="flex w-full">
                                                            <div className="flex overflow-x-auto overflow-y-hidden hide-scrollbar gap-2 w-full">
                                                                
                                                                {
                                                                    prevSearchHistory.map((prevHistoryItem, key) => (
                                                                        <span onClick={() => navigateToSearchPage(`/search/?q=${encodeURIComponent(prevHistoryItem)}`, `${prevHistoryItem}`) } key={`search-history-item-${key}`} className="inline-block shrink-0 lg:mr-4 mr-5">
                                                                            <div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--medium__xcmzq py-2 px-3 text-body1-strong xs:pl-1">
                                                                                <span>{prevHistoryItem}
                                                                                </span>
                                                                                <div className="flex cursor-pointer mr-1">
                                                                                    <svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-high-emphasis)'}}>
                                                                                        <use xlinkHref="#chevronLeft" />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                { topSearchKeywords.length > 0 &&
                                                <div className="py-2 hide-scrollbar">
                                                    <span className="cursor-pointer py-3 break-words block px-5 lg:px-4 xs:py-2">
                                                        <div className="flex justify-between items-start">
                                                            <div className="flex shrink-0 ml-4 mt-0.5">
                                                                <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
                                                                    <use xlinkHref="#searchTrend" />
                                                                </svg>
                                                            </div>
                                                            <div className="grow text-right">
                                                                <span className="grow text-subtitle-strong text-neutral-700">جستجوهای پرطرفدار
                                                                </span>
                                                                <div />
                                                            </div>
                                                        </div>
                                                    </span>
                                                    <div className="flex w-full">
                                                        <div className="flex overflow-x-auto overflow-y-hidden hide-scrollbar gap-2 w-full">
                                                            {
                                                                topSearchKeywords.map((keyword, key) => (
                                                                    <span onClick={() => navigateToSearchPage(`/search/?q=${encodeURIComponent(keyword.keyword)}`, `${keyword.keyword}`) } key={`top-search-keyword-${key}`} className="inline-block shrink-0 lg:mr-4 mr-5">
                                                                        <div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--medium__xcmzq py-2 px-3 text-body1-strong xs:pl-1">
                                                                            <span>{keyword.keyword} 
                                                                            </span>
                                                                            <div className="flex cursor-pointer mr-1">
                                                                                <svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-high-emphasis)'}}>
                                                                                    <use xlinkHref="#chevronLeft" />
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                    </span>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="grow flex flex-col overflow-y-auto">
                                        <div className="grow flex flex-col styles_children__hHq5Q hide-scrollbar">
                                            <div className="pb-4 br-list-vertical-no-padding-200 top-0 right-0">
                                                <div className="lg:px-4">
                                                    <div className="px-5 flex flex-col">
                                                        { searchResultWithCats.length > 0 &&
                                                        <div className="br-list-vertical-no-padding-200">
                                                            { 
                                                                searchResultWithCats.map((item, key) => (
                                                                    <span key={`search-auto-with-cat-${key}`} onClick={() => navigateToSearchPage(`/search/${item.catUrl}/?q=${encodeURIComponent(searchTxt)}`, `${searchTxt}`) }>
                                                                        <span className="cursor-pointer py-3 break-words block !py-2">
                                                                            <div className="flex justify-between items-start">
                                                                                <div className="flex shrink-0 ml-4 mt-0.5">
                                                                                    <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
                                                                                        <use xlinkHref="#searchSearch" />
                                                                                    </svg>
                                                                                </div>
                                                                                <div className="grow text-right">
                                                                                    <span className="grow text-subtitle-strong text-neutral-700">{item.productTitle}
                                                                                    </span>
                                                                                    <div>
                                                                                        <div className="text-body1-strong">
                                                                                            <span className="text-neutral-500">در دسته 
                                                                                            </span> 
                                                                                            <span className="text-secondary-500"> {item.catTitle}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                                                    </span>
                                                                ))
                                                            }
                                                        </div>
                                                        }
                                                        { searchResultWithoutCats &&
                                                        <div className="br-list-vertical-no-padding-200">
                                                            {
                                                                searchResultWithoutCats.map((item, key) => (
                                                                    <div key={`search-auto-without-cat-${key}`} onClick={() => navigateToSearchPage(`/search/?q=${encodeURIComponent(searchTxt)}`, `${searchTxt}`) } >
                                                                        <span className="cursor-pointer py-3 break-words block !py-2">
                                                                            <div className="flex justify-between items-center">
                                                                                <div className="flex shrink-0 ml-4">
                                                                                    <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
                                                                                        <use xlinkHref="#searchSearch" />
                                                                                    </svg>
                                                                                </div>
                                                                                <div className="grow text-right">
                                                                                    <span className="grow text-subtitle-strong text-neutral-700">{item.productTitle} 
                                                                                    </span>
                                                                                    <div />
                                                                                </div>
                                                                                <div className="flex items-center shrink-0 mr-4">
                                                                                    <div className="flex cursor-pointer">
                                                                                        <svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
                                                                                            <use xlinkHref="#searchPlaceSuggest" />
                                                                                        </svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </span>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop />
        </Sheet>

    );
}

export default SheetSearchMobile;